module.exports = __webpack_public_path__ + "img/invoice-example.c01d9f8d.png";